import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const ROUTES_MAP = [
  {
    id: 'NavigationMenu.Users',
    path: '/users',
  },
  {
    id: 'NavigationMenu.Products',
    path: '/products',
  },
  {
    id: 'NavigationMenu.Orgs',
    path: '/orgs',
  },
];

const NavigationMenuContainer = styled.ul`
  width: 240px;
  margin: 0px 40px;
  display: flex;
  flex-direction: column;
`;

const LinkOption = styled.li`
  width: 100%;
  height: 36px;
  display: flex;
  align-items: center;
`;

const StyledNavLink = styled(NavLink).attrs({ activeClassName: 'active' })`
  width: 100%;
  text-decoration: none;
  color: ${props => props.theme.BLACK};
  padding: 8px 10px;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;

  &.active {
    color: ${props => props.theme.WHITE};
    background: ${props => props.theme.PRIMARY};
  }
`;

function NavigationMenu({ t }) {
  return (
    <NavigationMenuContainer id="NavigationMenu">
      {ROUTES_MAP.map(route => (
        <LinkOption key={route.id}>
          <StyledNavLink id={route.id} to={route.path}>
            {t(route.id)}
          </StyledNavLink>
        </LinkOption>
      ))}
    </NavigationMenuContainer>
  );
}

NavigationMenu.propTypes = {
  t: PropTypes.func.isRequired, // supplied from withTranslation
};

export default withTranslation()(NavigationMenu);
